<template>
	<BoxNumbersNew
		:numbers="props.numbers"
		:is-color="props.isColor"
		:class-container-first-block="props.classContainerFirstBlock"
		:show-btn-detail="props.showBtnDetail"
	/>
</template>

<script setup lang="ts">
import BoxNumbersNew from '~/components/pages/results/BoxNumbersNew.vue'

defineOptions({
	name: 'BoxNumbers',
})

const props = defineProps({
	numbers: {
		type: Object,
		required: true,
	},
	isColor: {
		type: Boolean,
		default: true,
	},
	classContainerFirstBlock: {
		type: String,
		default: 'mx-auto flex flex-wrap smm:flex-nowrap justify-center items-center gap-x-1.5 gap-y-2.5',
	},
	showBtnDetail: {
		type: Boolean,
		default: true,
	},
})
</script>
